import styles from "./styles.module.scss";

export const renderFieldData = (
  label: string,
  data: string,
  dataStyle?: object
) => {
  return (
    <div className={styles.dataContainer}>
      <div className={styles.label}>{label}</div>

      <div className={styles.data}>
        <div style={dataStyle}>{data}</div>
      </div>
    </div>
  );
};
